import React, {useEffect} from 'react'
import Image from '@components/Image'
import {EVENTS} from '@helpers/analytics/events'
import {BrowseTaxonomies} from '@helpers/analytics/events/browse'
import {sendEvent} from '@helpers/analytics/sendEvents'
import classnames from '@helpers/misc/classnames'
import useEventsBaseProperties from '@hooks/useEventsBaseProperties'
import useIsDarkMode from '@hooks/useIsDarkMode'
import formatNumber from '@i18n/formatNumber'
import {useTranslation} from 'next-i18next'

import useUpselling from './hooks/useUpselling'
import AddToCart from './AddToCart'

export default function Inner() {
  const products = useUpselling()
  const {t} = useTranslation('generic')
  const [addingItem, setAddingItem] = React.useState(null)
  const isDarkMode = useIsDarkMode()
  const eventBaseProperties = useEventsBaseProperties()
  const baseProperties = useEventsBaseProperties()

  useEffect(() => {
    sendEvent<BrowseTaxonomies['upsellingViewed']>(EVENTS.browse.upsellingViewed, {
      itemsAmount: products.length,
      productsIds: products.length ? products.map(p => p._id).join(',') : null,
      ...baseProperties
    })
  }, [])

  return (
    <>
      <div className="flex flex-col space-y-8 py-4">
        {products.map(product => (
          <div
            className="flex sm:space-x-4 space-x-3 cursor-pointer"
            key={`upselling_${product._id}`}
            onClick={() => {
              setAddingItem(product._id)
            }}>
            <div className="text-base min-w-[96px] h-24 rounded-lg overflow-hidden relative">
              <Image src={product.image?.url} alt={product.name} layout="fill" objectFit="cover" />
            </div>
            <div className="flex flex-col text-sm overflow-hidden max-h-[96px]">
              <div className="font-semibold mb-0 sm:mb-1 overflow-hidden whitespace-nowrap text-ellipsis">
                {product.name}
              </div>
              <div
                className={classnames({
                  'mb-1 overflow-hidden whitespace-nowrap text-ellipsis': true,
                  'text-gray-500': !isDarkMode,
                  'text-gray-300': isDarkMode
                })}>
                {product.description}
              </div>
              <div
                className={classnames({
                  'mb-2': true,
                  'text-gray-700': !isDarkMode,
                  'text-gray-200': isDarkMode
                })}>
                {formatNumber(product.availabilityAt.finalPrice, 'money')}
              </div>
              <a className="font-semibold underline">{t('fields.add')}</a>
            </div>
          </div>
        ))}
      </div>
      <AddToCart onClose={() => setAddingItem(null)} productId={addingItem} />
    </>
  )
}
